/** @format */

import { defaultActions } from '../../core/actionsDefault';

// const _ = require('underscore');

export const clientsConstants = {
    CLIENTS_LIST: 'clients_list',
    CLIENTS_ITEM: 'clients_item',
    CLIENTS_EDIT: 'clients_edit',
    CLIENTS_DELETE: 'clients_delete',
    CLIENTS_MANAGE: 'clients_manage',
    CLIENT_ADD: 'client_add',
    CLIENT_CHECK: 'client_check',
    CLIENT_STREET_CHECK: 'client_street_check',
    CLIENT_CITY_CHECK: 'client_city_check',
    CLIENT_BOROUGH_CHECK: 'client_borough_check',
    CLIENT_DISTRICT_CHECK: 'client_district_check',
    CLIENT_STATE_CHECK: 'client_state_check',

    CLIENT_LIST_SHORT: 'clients_list_short',
};

export class clientsActions extends defaultActions {}
